export default function Excel_Top_Bottom_Rules() {
  return <div>Excel_Top_Bottom_Rules</div>;
}
